<table class="table" style="background-color:white;">

  <tr>
    <td style="background-color:#0f2b46;color:white;" colspan="2">Order Detail</td>
    <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
  </tr>
</table>


<table class="table table-hover text-center  table-bordered">

  <tr>
    <td *ngFor="let x of serviceMode; let i=index">
      <table class="table table-hover text-center  table-bordered">
        <tr>
          <td colspan="2">
            <p style="background-color: #0f2b46;color: white;">Service Mode</p>
          </td>

        </tr>
        <tr>
          <td>
            <b>Reference Id</b> :
          </td>
          <td>
            {{x.ezipayRefrenceid}}
          </td>
        </tr>
        <tr>
          <td>
            <b>Service Name</b> :
          </td>
          <td>
            <span>{{x.serviceName}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Destination</b> :
          </td>
          <td>
            <span>{{x.destination}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Transaction Status</b> :
          </td>
          <td>
            <span>{{x.transactionStatus}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Amount</b> :
          </td>
          <td>
            <span>USD {{x.amount}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Transaction Timestamp</b> :
          </td>
          <td>
            <span>{{x.transactionDate| date :'medium' }}</span>
          </td>
        </tr>

      </table>

    </td>
    <td *ngFor="let x of paymentMode; let i=index">
      <table class="table table-hover text-center  table-bordered">
        <tr>
          <td colspan="2">
            <p style="background-color: #0f2b46;color: white;">Payment Mode</p>
          </td>

        </tr>
        <tr>
          <td>
            <b>Reference Id</b> :
          </td>
          <td>
            {{x.ezipayRefrenceid}}
          </td>
        </tr>
        <tr>
          <td>
            <b>Service Name</b> :
          </td>
          <td>
            <span>{{x.serviceName}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Destination</b> :
          </td>
          <td>
            <span>{{x.destination}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Transaction Status</b> :
          </td>
          <td>
            <span>{{x.transactionStatus}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Amount</b> :
          </td>
          <td>
            <span>USD {{x.amount}}</span>
          </td>
        </tr>
        <tr>
          <td>
            <b>Transaction Timestamp</b> :
          </td>
          <td>
            <span>{{x.transactionDate| date :'medium' }}</span>
          </td>
        </tr>

      </table>

    </td>
  </tr>


</table>

